import BaseModelAPI from '../BaseModelAPI';

export default class ReportTracingAbilityDetailList extends BaseModelAPI {

	static entity = 'newreport2135list'
	static entityName = 'reporttracingabilitydetail';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
